import { useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { useSeo } from "../components/site/Layout";
import { PageHero, Section, CheckList, ThirdPartyNotice, AidNotice, CtaBand, Faq } from "../components/site/blocks";
import { SERVICES } from "../data/site";
import { SERVICE_CONTENT } from "../data/services";
import NotFound from "./NotFound";

const TABS = [["blocks", "Ce que nous faisons"], ["forWho", "Pour qui"], ["deliverables", "Livrables"], ["faq", "Questions"]];

export default function ServicePage() {
  const { slug } = useParams();
  const meta = SERVICES.find((s) => s.slug === slug);
  const c = SERVICE_CONTENT[slug];
  const [tab, setTab] = useState("blocks");
  useSeo(meta ? meta.title : "Service", c?.meta);
  if (!meta || !c) return <NotFound />;
  const intro = c.intro.split(". ")[0] + ".";
  return (
    <div data-testid={`service-page-${slug}`}>
      <PageHero eyebrow={c.eyebrow} title={meta.title} intro={intro} image={meta.image} imageAlt={c.imageAlt}>
        <Link to={`/contact?besoin=${encodeURIComponent(meta.title)}`} className="btn-accent" data-testid="service-quote-cta">Demander un devis <ArrowRight className="h-5 w-5" aria-hidden="true" /></Link>
        <Link to="/prendre-rdv" className="btn-outline" data-testid="service-rdv-cta">Prendre RDV</Link>
      </PageHero>
      <Section testid="service-tabs">
        <div role="tablist" aria-label="Détails du service" className="inline-flex flex-wrap gap-1 rounded-full bg-brand-50 border border-brand/15 p-1">
          {TABS.map(([k, l]) => (
            <button key={k} role="tab" type="button" aria-selected={tab === k} aria-controls={`panel-${k}`} onClick={() => setTab(k)} data-testid={`service-tab-${k}`}
              className={`rounded-full px-4 py-2 font-display text-[15px] transition-colors ${tab === k ? "bg-navy text-white" : "text-navy hover:bg-white"}`}>{l}</button>
          ))}
        </div>
        <div id={`panel-${tab}`} role="tabpanel" className="mt-8 rise" key={tab}>
          {tab === "blocks" && (
            <div className="grid sm:grid-cols-2 gap-4">
              {c.blocks.map((b) => <div key={b.t} className="card-soft"><h3 className="text-xl">{b.t}</h3><p className="mt-2 text-[15px] text-slate-600">{b.d}</p></div>)}
            </div>
          )}
          {tab === "forWho" && <div className="max-w-2xl"><CheckList items={c.forWho} /></div>}
          {tab === "deliverables" && <div className="max-w-2xl"><CheckList items={c.deliverables} /></div>}
          {tab === "faq" && <Faq items={c.faq} prefix="service-faq" />}
        </div>
        <div className="mt-10 grid lg:grid-cols-2 gap-4"><ThirdPartyNotice /><AidNotice /></div>
        <ul className="mt-12 flex flex-wrap gap-2">
          {SERVICES.filter((s) => s.slug !== slug).map((s) => (
            <li key={s.slug}><Link to={`/services/${s.slug}`} className="inline-flex rounded-full border border-brand/25 px-4 py-2 text-sm text-navy hover:bg-brand-50 transition-colors">{s.title}</Link></li>
          ))}
        </ul>
      </Section>
      <CtaBand />
    </div>
  );
}
